import React from "react";
import Container from "./container";
import { cn } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { buildImageObj } from "../lib/helpers";
import PortableText from "./portableText";
//import Fancybox from "./fancybox";
import Icon from "./icon";
import loadable from '@loadable/component';

const Fancybox = loadable(() => import('./fancybox'));

import * as styles from "../styles/components/fc-team.module.css";

const Team = (props) => {

  const {
    _key,
    title,
    _rawDescription,
    members
  } = props;

  return (
    <div className={styles.root} key={_key}>
      <Container>
        <div className={styles.contentWrap}>
          {title && (<h2 className={styles.title}>{title}</h2>)}
          {_rawDescription && (<div className="entry-content"><PortableText blocks={_rawDescription} /></div>)}
        </div>
        {members && members.length > 0 && (
          <div className={cn("grid", styles.grid)}>
            {members.map(col => {
              return (
                <div className={cn("col-12 col-md-6 col-xl-4", styles.col)} key={col._key}>
                  {col.photo && col.photo.asset && (
                    <div className={styles.image}>
                      {col._rawBio ? (
                        <Fancybox options={{ 
                          dragToClose: false,
                          groupAttr: false,
                          Hash: false,
                        }}>
                          <a href={"#" + col._key} data-fancybox={col._key} className={styles.link}>
                            <img
                              src={imageUrlFor(buildImageObj(col.photo))
                                .auto("format")
                                .url()}
                              alt={col.photo.alt}
                            />
                          </a>
                        </Fancybox>
                      ) : (
                        <img
                          src={imageUrlFor(buildImageObj(col.photo))
                            .auto("format")
                            .url()}
                          alt={col.photo.alt}
                        />
                      )}
                    </div>
                  )}
                  {(col.name || col.position || col._rawBio) && (
                    <div className={styles.text}>
                      {col.name && (
                        <h3 className={cn("h4", styles.name)}>
                          {col._rawBio ? (
                            <Fancybox options={{ 
                              dragToClose: false,
                              groupAttr: false,
                              Hash: false,
                            }}>
                              <a href={"#" + col._key} data-fancybox={col._key}>
                                {col.name}
                              </a>
                            </Fancybox>
                          ) : (
                            col.name
                          )}
                        </h3>
                      )}
                      {col.position && (<div className={styles.position}>{col.position}</div>)}
                      {col._rawBio && (
                        <Fancybox options={{ 
                          dragToClose: false,
                          groupAttr: false,
                          Hash: false,
                        }}>
                          <a href={"#" + col._key} className={cn("link link-no-svg", styles.readBio)} data-fancybox={col._key}>
                            Read Bio
                          </a>
                        </Fancybox>
                      )}
                    </div>
                  )}

                  {col._rawBio && (
                    <div id={col._key} className={styles.bio}>
                      {col.photo && col.photo.asset && (
                        <div className={styles.image}>
                          <img
                            src={imageUrlFor(buildImageObj(col.photo))
                              .auto("format")
                              .url()}
                            alt={col.photo.alt}
                          />
                        </div>
                      )}
                      <div className={styles.text}>
                        {col.name && (<h3 className={cn("h4", styles.name)}>{col.name}</h3>)}
                        {col.position && (<div className={styles.position}>{col.position}</div>)}
                        {col._rawBio && (
                          <div className={cn("entry-content", styles.content)}>
                            <PortableText blocks={col._rawBio} />
                          </div>
                        )}
                      </div>
                      
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </Container>
    </div>
  );
}

export default Team;
